import { redirectToStaticPage } from '../app/actions';
import { CONFERENCE_JOINED } from '../base/conference/actionTypes';
import {
  JitsiConferenceErrors,
  JitsiConferenceEvents
} from '../base/lib-jitsi-meet';
import MiddlewareRegistry from '../base/redux/MiddlewareRegistry';

import { SET_DETAILS } from './actionTypes';
import { STATUSES } from './constants';
import logger from './logger';

import { createVpaasConferenceJoinedEvent } from '../analytics/AnalyticsEvents';
import { sendAnalytics } from '../analytics/functions';

import { getVpaasTenant, isVpaasMeeting } from './functions';

/**
 * Tracks the conference join event if the meeting is a vpaas one.
 *
 * @param {Store} state - The app state.
 * @returns {Function}
 */
function _maybeTrackVpaasConferenceJoin(state) {
  if (isVpaasMeeting(state)) {
    sendAnalytics(createVpaasConferenceJoinedEvent(getVpaasTenant(state)));
  }
}

/**
 * The redux middleware for jaas.
 *
 * @param {Store} store - The redux store.
 * @returns {Function}
 */
MiddlewareRegistry.register((store) => (next) => async (action) => {
  switch (action.type) {
    case CONFERENCE_JOINED: {
      _maybeTrackVpaasConferenceJoin(store.getState());
      const { conference } = action;

      if (store.getState()['features/base/config'].iAmRecorder) {
        // We don't register anything on web if we are in iAmRecorder mode
        return next(action);
      }

      conference.on(
        JitsiConferenceEvents.CONFERENCE_ERROR,
        (errorType, errorMsg) => {
          errorType === JitsiConferenceErrors.SETTINGS_ERROR &&
            logger.error(errorMsg);
        }
      );
      break;
    }

    case SET_DETAILS: {
      const { status } = action.payload;

      if (status === STATUSES.BLOCKED) {
        store.dispatch(redirectToStaticPage('/static/planLimit.html'));
      }
      break;
    }
  }

  return next(action);
});
